import { 
  AppBar, 
  Toolbar, 
  Typography, 
  IconButton, 
  Box,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { 
  Menu as MenuIcon,
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon,
} from '@mui/icons-material';
import { styled, alpha } from '@mui/material/styles';
import React from 'react';

// Paleta de cores idêntica à sidebar
const colors = {
  primary: '#5AB9D3',
  primaryLight: '#6AC9E3',
  primaryDark: '#4AA5C0',
  secondary: '#101A3A',
  secondaryLight: '#1A2747',
  white: '#FFFFFF',
  textLight: '#E2E8F0',
  accent: '#38A169',
  error: '#E53E3E',
  success: '#38A169'
};

// Componente estilizado para o gradiente de fundo
const GradientAppBar = styled(AppBar)(({ theme }) => ({
  background: `linear-gradient(160deg, ${colors.secondary} 0%, ${colors.secondaryLight} 100%)`,
  boxShadow: 'none',
  borderBottom: `1px solid ${alpha(colors.primary, 0.2)}`,
  zIndex: theme.zIndex.drawer + 1,
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '100%',
    background: `radial-gradient(circle at 85% 15%, ${alpha(colors.primary, 0.15)} 0%, transparent 60%)`,
    pointerEvents: 'none',
    zIndex: -1
  }
}));

// Componente estilizado para os botões da AppBar
const AppBarButton = styled(IconButton)(({ theme }) => ({
  color: colors.white,
  marginLeft: theme.spacing(1),
  padding: theme.spacing(1),
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: alpha(colors.primary, 0.2),
    transform: 'scale(1.1)'
  },
  '&.Mui-focusVisible': {
    backgroundColor: alpha(colors.primary, 0.3)
  }
}));


const AppBarComponent = ({ title, onMenuClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <GradientAppBar position="fixed">
      <Toolbar sx={{ 
        minHeight: '64px',
        paddingRight: { xs: '12px', sm: '24px' }
      }}>
        {/* Botão do menu (mobile) */}
        {isMobile && (
          <AppBarButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={onMenuClick}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </AppBarButton>
        )}

        {/* Título */}
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            fontWeight: 600,
            letterSpacing: '0.05em',
            color: colors.white,
            fontSize: { xs: '1rem', sm: '1.1rem' },
            textTransform: 'uppercase'
          }}
        >
          {title}
        </Typography>


        {/* Ícones de ação */}
        <Box sx={{ display: 'flex' }}>
          {!isMobile && (
            <AppBarButton
              size="large"
              aria-label="show notifications"
              color="inherit"
            >
              <NotificationsIcon />
            </AppBarButton>
          )}

          <AppBarButton
            size="large"
            edge="end"
            aria-label="account of current user"
            aria-haspopup="true"
            color="inherit"
          >
            <AccountCircleIcon />
          </AppBarButton>
        </Box>
      </Toolbar>
    </GradientAppBar>
  );
};

export default AppBarComponent;